import { renderTemplateUtil } from "shared/components/template/renderTemplateUtil";

type RenderPillarTableHeadingProps = {
  /** The column heading, plain text or a Handlebars template */
  heading?: string;
  /** What a template heading is rendered against */
  templateData?: unknown;
};

/**
 * Only a heading with `{{` in it is a template, so every existing plain heading
 * keeps rendering exactly as written.
 */
export const isPillarTableHeadingTemplate = (heading?: string): boolean =>
  Boolean(heading?.includes("{{"));

/**
 * A column heading as it should be shown. A template heading is rendered against
 * `templateData`; with nothing to render against its placeholders come out
 * empty, which is better than showing the raw `{{…}}` to the reader.
 */
export const renderPillarTableHeading = ({
  heading = "",
  templateData,
}: RenderPillarTableHeadingProps): string => {
  if (!isPillarTableHeadingTemplate(heading)) {
    return heading;
  }

  return renderTemplateUtil({
    template: heading,
    templateData: templateData ?? {},
  })
    .replace(/\s+/g, " ")
    .trim();
};
